import { render, staticRenderFns } from "./RequestProfileDataModal.vue?vue&type=template&id=ed128f16"
import script from "./RequestProfileDataModal.vue?vue&type=script&lang=js"
export * from "./RequestProfileDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports